import _ from 'lodash';
import BaseViewController from '../../common/services/base-view-controller';

class NestController extends BaseViewController {
    constructor($scope, $state, $rootScope,  LoadedModel) {
        super($scope, $state, LoadedModel);
        this._$rootScope = $rootScope;
        this.viewKey = this.nestViewKey;
        const blankView =  this.model.getView(this.blankViewKey);
        const fisibilityView =  this.model.getView(this.feasibilityViewKey);


        if(this.getCurrentView()) {
            this.loadCurrentView();
        } else if(blankView) {
            this.loadView(blankView, this.meshViewKey);
        } else if (fisibilityView) {
            this.loadView(fisibilityView, this.feasibilityViewKey);
        } else if (this.model.isStepPassed('nest')) {
            this.updateCurrentView(this.model.getViewData('nest'));
        } else if (this.model.isStepPassed('feasibility')) {
            this.updateCurrentView(this.model.getViewData('blank'), 'blank');
        } else if (this.model.isStepPassed('part')) {
            this._$state.go('feasibility');
        } else {
            this._$state.go('home');
        }
        this.updateCurrentView();
        this._masterNestValues  = this.model.getCurrNestValues();
        this.model.calculateUtilizationInfo();
    }

    isDataChanged() {
      this.model.dataChanged = JSON.stringify(this._masterNestValues) !== JSON.stringify(this.model.getCurrNestValues());
      return !this.model.isStepPassed('nest') || this.model.dataChanged;
    }

    sendModel() {
        this.requestInProgress = this.model.requestInProgress =true;
        const uniqParam = this.model.uuid();
        this.model.getProgress(uniqParam, 'nest', true);
        this.model.sendData(this.viewKey, false, uniqParam).then((results) => {
            this.model.generateExpTime();
            this.requestInProgress = this.model.requestInProgress = false;
            const res = results.toJSON();
            this.model.invalidateSnapshots('nest');
            _.extend(this.model, res);
            if(!res.nestN3) {
                delete this.model.nestN3;
            }
            this.updateCurrentView(this.model.getViewData('nest'));
            this.model.calculateUtilizationInfo();
            this._$scope.$broadcast('solverFinished', {step: 'nest'});
            this._masterNestValues  = this.model.getCurrNestValues();
        }, (error) => {
            this._$rootScope.$broadcast('showErrorDialog', {type: 'nest'});
            this.model.generateExpTime();
            this.requestInProgress = this.model.requestInProgress = false;
        });
    }
}

NestController.$inject = ['$scope', '$state', '$rootScope', 'LoadedModel'];

export default NestController;



// WEBPACK FOOTER //
// ./client/app/components/nest/nest.controller.js